/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const ArrowTrendUpSolidV6 = (props) => (
  <Icon {...props} name="Arrow Trend Up Solid V6">
    <path d="M10.667 5.333c-.492 0-.889-.397-.889-.889s.397-.889.889-.889h4.444c.492 0 .889.397.889.889v4.444c0 .492-.397.889-.889.889s-.889-.397-.889-.889V6.591l-4.706 4.703a.888.888 0 0 1-1.256 0L5.307 8.369l-3.791 3.814a.889.889 0 0 1-1.257-1.256l4.445-4.444a.888.888 0 0 1 1.256 0l2.928 2.925 4.075-4.1-2.297.025z" />
  </Icon>
);

export default ArrowTrendUpSolidV6;
